import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { State, getIsUserLogged } from "app/reducers";
import { takeUntil } from "rxjs/operators";

import { SubscribingComponent } from "../../common";
import { PaymentService } from "app/payment/payment.service";
import { AuthService } from "app/users";

@Component({
  selector: "app-payment-execution",
  templateUrl: "./payment-execution.component.html",
  styleUrls: ["./payment-execution.component.scss"],
  standalone: false
})
export class PaymentExecutionComponent extends SubscribingComponent implements OnInit {
  constructor(
    private router: Router,
    private paymentService: PaymentService,
    private authService: AuthService,
    private store: Store<State>
  ) {
    super();
  }

  ngOnInit() {
    this.waitForLogin();
  }

  private waitForLogin(): void {
    let timeout = null;
    this.store
      .select(getIsUserLogged)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isLogged: boolean) => {
        if (isLogged) {
          this.executePayment();
          clearTimeout(timeout);
        } else {
          timeout = setTimeout(() => this.authService.logout(), 10000);
        }
      });
  }

  private executePayment(): void {
    const destination = "/premium-payment-completed";

    this.paymentService
      .afterPayPalExecution()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => this.router.navigateByUrl(destination),
        () => this.router.navigate(["/payment-abort"])
      );
  }
}
